import { useCurrency } from "../../context/CurrencyContext";

export default function CurrencySwitcher({ variant = "footer" }) {
  const { currency, setCurrency } = useCurrency();

  const Button = ({ value, label, flag }) => {
    const active = currency === value;
    return (
      <button
        type="button"
        data-testid={`currency-switch-${value.toLowerCase()}`}
        onClick={() => setCurrency(value)}
        aria-label={`Mostrar preços em ${label}`}
        className={`inline-flex items-center gap-1.5 px-3 py-1.5 text-[10px] tracking-[0.2em] uppercase font-semibold border transition-all ${
          active
            ? "bg-gold text-onyx border-gold"
            : variant === "footer"
              ? "bg-transparent text-alabaster/60 border-alabaster/20 hover:text-alabaster hover:border-alabaster/60"
              : "bg-transparent text-onyx/60 border-border hover:text-onyx hover:border-onyx"
        }`}
      >
        <span aria-hidden="true">{flag}</span>
        <span>{label}</span>
      </button>
    );
  };

  return (
    <div data-testid="currency-switcher" className="inline-flex items-center gap-1.5" role="group" aria-label="Selecionar moeda">
      <Button value="BR" label="R$ BRL" flag="🇧🇷" />
      <Button value="EU" label="€ EUR" flag="🇪🇺" />
    </div>
  );
}
